// Conformité — MDPH nécessaire + résumé financier (devis/prime/reste).
import { CircleDot, Loader2 } from "lucide-react";
import { useConformiteFetch, fmtEuro } from "./useConformiteFetch";

export default function ConformiteMdphWidget() {
  const { data, loading, error } = useConformiteFetch();

  if (loading) {
    return (
      <div
        className="rounded-xl p-5 h-full flex items-center justify-center"
        style={{ background: "var(--oh-bg-elevated)", border: "1px solid var(--oh-border)" }}
      >
        <Loader2 className="w-5 h-5 animate-spin" style={{ color: "var(--oh-text-muted)" }} />
      </div>
    );
  }
  if (error) {
    return (
      <div
        className="rounded-xl p-5"
        style={{ background: "var(--oh-bg-elevated)", border: "1px solid var(--oh-border)", color: "var(--oh-text-muted)" }}
      >
        Erreur MDPH : {error}
      </div>
    );
  }

  const t = data?.totaux || {};
  const summary = [
    { label: "Montant total devis", value: fmtEuro(t.montant_devis_total), color: "#8b5cf6" },
    { label: "Prime ANAH totale",   value: fmtEuro(t.montant_prime_total), color: "#10b981" },
    { label: "Reste à charge",      value: fmtEuro(t.reste_charge_total),  color: "var(--oh-stat-amber-text)" },
  ];

  return (
    <div
      className="rounded-xl p-5 h-full"
      style={{ background: "var(--oh-bg-elevated)", border: "1px solid var(--oh-border)" }}
      data-testid="conformite-mdph-widget"
    >
      <h3 className="font-semibold mb-4 flex items-center gap-2" style={{ color: "var(--oh-text)" }}>
        <CircleDot className="w-4 h-4" style={{ color: "#8b5cf6" }} />
        MDPH nécessaire
      </h3>
      <div className="flex items-center justify-center gap-8 py-6">
        <div className="text-center">
          <p className="text-4xl font-bold" style={{ color: "#10b981" }}>{t.mdph_oui || 0}</p>
          <p className="text-xs mt-1" style={{ color: "var(--oh-text-muted)" }}>Oui</p>
        </div>
        <div className="h-12 w-px" style={{ background: "var(--oh-border)" }} />
        <div className="text-center">
          <p className="text-4xl font-bold" style={{ color: "var(--oh-text-secondary)" }}>{t.mdph_non || 0}</p>
          <p className="text-xs mt-1" style={{ color: "var(--oh-text-muted)" }}>Non</p>
        </div>
      </div>
      <div className="mt-4 pt-4 space-y-3" style={{ borderTop: "1px solid var(--oh-border)" }}>
        <h4 className="text-xs font-semibold" style={{ color: "var(--oh-text-muted)" }}>RÉSUMÉ FINANCIER</h4>
        {summary.map((r) => (
          <div key={r.label} className="flex justify-between text-xs">
            <span style={{ color: "var(--oh-text-secondary)" }}>{r.label}</span>
            <span className="font-bold" style={{ color: r.color }}>{r.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
